import { BadgeKind } from "../types";

export const BADGE_ICONS: Record<BadgeKind, string> = {
	current: "fa-solid fa-spiral",
	wave: "fa-solid fa-water",
	camera: "fa-solid fa-camera",
	video: "fa-solid fa-video",
	wind: "fa-solid fa-wind",
	temp: "fa-solid fa-temperature-half",
};
export const SEARCH_ICONS: Record<string, string> = {
	station: "fa-solid fa-location-dot",
	port: "fa-solid fa-anchor"
};